<div class="dialog-header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{ title }}
</div>
<mat-dialog-content class="dialog-content">
    <div class="mat-elevation-z3 g-0">
        <app-tasks-table-mt
                [customColumns]=""
                [onlyTable]="true"
                [rowsPerPages]="20"
                [tasksData]="taskData"
                [widgetView]="true"
                [headerTransparent]="true">
        </app-tasks-table-mt>
    </div>
</mat-dialog-content>
